import moment from 'moment';

export default {
  selectedShow: (state, getters) => {
    return state.selectedShow;
  },
  ticketTime: (state, getters) => {
    return state.selectedShow && moment(state.selectedShow.DT, 'YYYYMMDDHHmm');
  },
  plainDateSelected: (state, getters) => {
    return getters.ticketTime ? getters.ticketTime.format('hh:mm A, MMMM D, YYYY') : '';
  },
  ticketDetail: (state, getters) => {
    return state.ticketDetail;
  },
  performanceId: (state, getters) => {
    return state.selectedShow && state.selectedShow.ID;
  },
  ticketTypes: (state, getters) => {
    let ticketTypes = state.ticketDetail.Ticket;
    if (ticketTypes.Name) {
      ticketTypes = [ticketTypes];
    }
    return ticketTypes || [];
  },
  totalTicketCount: (state, getters) => {
    const res = Object.values(state.ticketTypeCount).reduce((sum, count) => sum + count, 0);

    return res;
  },
  ticketTypeCount: state => {
    return state.ticketTypeCount;
  },
  seats: state => {
    return state.seats;
  },
  priceGroups: state => {
    return state.priceGroups;
  },
 
  ticketTypeCodes: function(state, getters) {
    const ttc = getters.ticketTypeCount;
    const tt = getters.ticketTypes;

    return tt
      .filter(t => ttc[t.Name] > 0)
      .reduce((obj, t) => {
        obj[t.Name] = t.Code;
        return obj;
      }, {});
  },
  totalTicketsPrice: function(state, getters) {
    const types = getters.ticketTypes;
    const counts = state.ticketTypeCount;
    const tPrice = types.reduce((sum, type) => sum + +type.Price * (+counts[type.Name] || 0), 0);
    return tPrice.toFixed(2);
  },
  totalServicePrice: function(state, getters) {
    const { ServiceCharge } = getters.ticketDetail;
    const tPrice = getters.totalTicketCount * ServiceCharge;
    return tPrice.toFixed(2);
  },
  priceSum: (state, getters) => {
    return +getters.totalTicketsPrice + +getters.totalServicePrice;
  },
  totalPrice: function(state, getters) {
    return (getters.priceSum - getters.giftCardMaxUsage).toFixed(2);
  },
  giftCardBalance: (state, getters) => {
    return state.giftCard.giftCardBalance || 0;
  },
  giftCardNumber: (state, getters) => {
    return state.giftCard.giftCardNumber || '';
  },
  giftCardPin: (state, getters) => {
    return state.giftCard.giftCardPin || '';
  },
  giftCardRedirectUrl: (state, getters) => {
    return state.giftCard.redirectUrl || '';
  },
  giftCardOrder: (state, getters) => {
    return state.giftCard.order || '';
  },
  giftCardMaxUsage: (state, getters) => {
    return getters.giftCardNumber ? Math.min(getters.giftCardBalance, +getters.priceSum) : 0;
  },
  selectedSeats: function(state, getters) {
    return state.selectedSeats;
  },
  paymentData: function(state, getters) {
    return state.paymentData;
  },
  countdown: (state, getters) => {
    return state.countdown;
  },
  holdId: (state, getters) => {
    return state.holdId;
  },
  logID: (state, getters) => {
    return state.logID;
  }
};
